import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { take, map, tap, filter, catchError } from 'rxjs/operators';
import { ApisService } from './services/apis.service';

@Injectable({ providedIn: 'root' })
export class UnsubscribeManagementGuard implements CanActivate {
  constructor(private apiService: ApisService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.apiService.getFocusFeatureFlagConditions().pipe(
      // take the current value then complete so we don't need to manually unsubscribe
      filter((v) => v !== null && v !== undefined),
      take(1),
      // normalize response to a boolean
      map((resp) => {
        if (typeof resp === 'boolean') return resp;
        if (resp && typeof resp === 'object') {
          if (resp.data && typeof resp.data.isUnsubscribeManagementEnabled === 'boolean') {
            return resp.data.isUnsubscribeManagementEnabled;
          }
          if (typeof resp.isUnsubscribeManagementEnabled === 'boolean') {
            return resp.isUnsubscribeManagementEnabled;
          }
        }
        return false;
      }),
      tap((enabled) => console.log('Unsubscribe Management Enabled (normalized):', enabled)),
      map((enabled) => {
        if (enabled) {
          return true;
        }
        // Redirect one level up from the current URL (do not preserve query or fragment)
        const fullUrl = state.url || '/';
        const pathOnly = fullUrl.split(/[?#]/)[0];
        const parentPath = pathOnly.replace(/\/[^\/]*$/, '') || '/';
        return this.router.parseUrl(parentPath);
      }),
      // If the HTTP call errors, deny access and redirect one level up instead of throwing
      catchError((err) => {
        console.error('Failed to load feature flag for unsubscribe management', err);
        const fullUrl = state.url || '/';
        const pathOnly = fullUrl.split(/[?#]/)[0];
        const parentPath = pathOnly.replace(/\/[^\/]*$/, '') || '/';
        return of(this.router.parseUrl(parentPath));
      })
    );
  }
}
